module.exports = __webpack_public_path__ + "static/media/23.521ca9a0.jpg";